import { TmapApp } from '@tmap-web-lib/tmap-app-interface'
import { useCallback } from 'react'

import { GeoCoordinates } from '@/types/shared'

export function useRequestCurrentPosition() {
  return useCallback(({ timeout = 5000, retry, maxRetries = 3 }: UseRequestCurrentPositionOptions = {}) => {
    return new Promise<GeoCoordinates | null>((resolve) => {
      let retries = 0
      const getCurrentPosition = () => {
        TmapApp.getCurrentPosition().then((coordinates) => {
          if (coordinates != null) {
            resolve({
              latitude: coordinates[0],
              longitude: coordinates[1],
            })
          } else {
            if (retry) {
              if (retries === maxRetries) {
                resolve(null)
              } else {
                retries += 1
                getCurrentPosition()
              }
            } else {
              resolve(null)
            }
          }
        })
      }

      getCurrentPosition()

      if (!retry) {
        setTimeout(() => {
          // 이미 resolve 호출됐다면 아무일도 일어나지 않음.
          resolve(null)
        }, timeout)
      }
    })
  }, [])
}

export interface UseRequestCurrentPositionOptions {
  timeout?: number
  retry?: boolean
  maxRetries?: number
}
